import { render, staticRenderFns } from "./MotoristaDetalhes.vue?vue&type=template&id=a4f4468e"
import script from "./MotoristaDetalhes.vue?vue&type=script&lang=js"
export * from "./MotoristaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports